import { IonAlert, IonButton, IonButtons, IonCheckbox, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonList, IonListHeader, IonLoading, IonModal, IonPage, IonRow, IonSegment, IonSegmentButton, IonTextarea, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, camera, informationCircleOutline, logoUsd, openOutline, receipt } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { assinarArquivoProjeto, carregaAssinatura, requestService, urlBase } from '../../../../../Utils/Services';
import { UserPhoto } from '../../../../../components/usePhotoGallery';
import "./OrdensWorkflow.css";

import { Toast } from '@capacitor/toast';
import * as icons from 'ionicons/icons';
import Signature from "signature_pad";
import { Swiper as SwiperInterface } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import '@ionic/react/css/ionic-swiper.css';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import { MessageContext } from '../../../../../contexts/MessageContext';

type IconType = typeof import('ionicons/icons/index');


type Props = {
  projetoid: string;
  onDismiss: () => void;
};

const OrdensWorkflow: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const location = useLocation<any>();
  const [idProjeto, setIdProjeto] = useState("");
  const [dadosProjeto, setDadosProjeto] = useState<any>([]);
  const [operacaoCarregada, setOperacaoCarregada] = useState(false);
  const [temHoraFim, setTemHoraFim] = useState(false);
  const [showCarregando, setShowCarregando] = useState(false);
  const [showModalConfirmarAssinatura, setShowModalConfirmarAssinatura] = useState(false);
  const [showAssinatura, setShowAssinatura] = useState(false);
  const [arquivoParaAssinar, setArquivoParaAssinar] = React.useState<string>();
  const [arquivoIndiceParaAssinar, setArquivoIndiceParaAssinar] = React.useState<string>();
  const [showAlertConfirmarAssinatura, setShowAlertConfirmarAssinatura] = useState(false);
  const [showModalDadosAssinatura, setShowModalDadosAssinatura] = useState(false);
  const [dadosAssinatura, setDadosAssinatura] = useState<any>([]);
  const [assinaturaBlob, setAssinaturaBlob] = useState<string>();
  const [alertaPreenchimento, setAlertaPreenchimento] = useState(false);
  const [botaoAtivo, setBotaoAtivo] = useState(true);
  const [selectedTab, setSelectedTab] = useState<string>("0");
  //const sliderRef = useRef<HTMLIonSlidesElement>(null);
  const [swiperInstance, setSwiperInstance] = useState<SwiperInterface>();
  const [informacoes, setInformacoes] = useState<any>([]);
  const [valores, setValores] = useState<any>([]);
  const [fotos, setFotos] = useState<any>([]);
  const [arquivos, setArquivos] = useState<any>([]);
  const [showLoading, setShowLoading] = useState(false);
  const [checkedTermo, setCheckedTermo] = useState(false);
  const [signaturePad, setSignaturePad] = useState<any>(null);
  const [savedSignature, setSavedSignature] = useState<any>(null);
  const [indiceEntrada, setIndiceEntrada] = useState<any>();
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  const contentRef = useRef<HTMLIonContentElement | null>(null);

  useIonViewDidEnter(() => {

    setEsconderMenu(true);

    if (params.projetoid) {
      setIdProjeto(params.projetoid);
    }
  });
  useEffect(() => {

    if (idProjeto != "") {
      console.log("entrou no useEffect");
      carregarProjeto();
    }
  }, [idProjeto]);

  let params: any = {
    projetoid: "",
    abrirInserirAgendamento: false
  }
  params = useParams();

  if (location && location.state && location.state.projetoid) {
    params.projetoid = location.state.projetoid;
  }


  if (props.projetoid) {
    params = {
      projetoid: props.projetoid
    }
  }

  const readyPad = () => {
    let wrapper = document.getElementById("signature-pad");
    let canvas = wrapper?.querySelector("canvas");
    if (canvas) {

      let tempSignaturePad = new Signature(canvas, {
        backgroundColor: "rgb(255, 255, 255)"
      });
      setSignaturePad(tempSignaturePad);
    }
  };

  const handleClear = () => {
    signaturePad.clear();
  };



  function carregarProjeto() {
    if (params.projetoid != "" && params.projetoid != undefined) {
      if (!operacaoCarregada) {
        setOperacaoCarregada(true);
        var token: string = "";
        var tkn = localStorage.getItem("token");
        if (typeof (tkn) === "string") { token = tkn; }
        console.log("projetoid", params.projetoid);
        const getoperacao = async () => {

          setShowLoading(true);
          const resp = await fetch(urlBase.url + "/mobile/ordens/" + params.projetoid.replaceAll(/#/g, '%23'),
            {
              method: urlBase.method,
              headers: [
                ["token", token],
                ["perfil", window.localStorage.getItem("perfil") || ""],
                ["marca", window.localStorage.getItem("marca") || ""],
              ],
              credentials: 'include'
            });
          const operacao = await resp.json();
          //if (resp.status === 400 || resp.status === 401) history.replace("/primeiroacesso/");
          if (operacao.Item !== undefined) {

            preencherDadosOperacao(operacao.Item, true);


            console.log("abrirInserirAgendamento", params.abrirInserirAgendamento);

            setTemHoraFim(operacao.Item.dataEncerramento ? true : false);

          }

          setShowLoading(false);

        }

        getoperacao();
      }
    }
    return "";
  }

  function preencherDadosOperacao(projeto: any, slideDoStatus: Boolean) {

    //console.log("operacao", projeto);
    setDadosProjeto(projeto);

    let preencherInformacoes: any[] = [];
    let preencherValores: any[] = [];
    let preencherFotos: any[] = [];
    let preencherArquivos: any[] = [];
    let newPhotosProjeto: UserPhoto[] = [];
    let newArquivosProjeto: UserPhoto[] = [];

    //console.log("contar", projeto.configWorkflow.length);
    projeto.configWorkflow.map((value: any, index: any) => {
      //console.log("preencherDadosOperacao_slideDoStatus", slideDoStatus);
      if (slideDoStatus && value.status === projeto.statusWorkflow) {
        swiperInstance?.slideTo(parseInt(index));
      }
      preencherInformacoes.push(value.campoInformacoes);
      preencherValores.push(value.campoValores);


      if (value.campoFotos) {
        let _photos: string[] = value.campoFotos;


        _photos.map(async (valorPath: any, indexPath: any) => {
          newPhotosProjeto.push({ filepath: valorPath, webviewpath: valorPath });
        })

        preencherFotos.push(newPhotosProjeto);
        newPhotosProjeto = [];

      }
      else {
        preencherFotos.push("");
      }

      if (value.campoArquivos) {
        let _photos: string[] = value.campoArquivos;


        _photos.map(async (valorPath: any, indexPath: any) => {
          newArquivosProjeto.push({ filepath: valorPath, webviewpath: valorPath });
        })

        preencherArquivos.push(newArquivosProjeto);
        newArquivosProjeto = [];

      }
      else {
        preencherArquivos.push("");
      }





    });


    console.log("preencherInformacoes", preencherInformacoes);
    setInformacoes(preencherInformacoes);
    setValores(preencherValores);
    setFotos(preencherFotos);
    console.log("preencherArquivos", preencherArquivos);
    setArquivos(preencherArquivos);
  }

  const scrollToTop = () => {
    contentRef.current && contentRef.current.scrollToTop();
  };

  function onTabChange(value: string) {
    console.log(value);
    if (value === "" || value == null || value === undefined) return;

    swiperInstance?.slideTo(parseInt(value));
  }


  async function onSlideChange() {
    let slideIndex = swiperInstance?.activeIndex;

    console.log(slideIndex);

    if (slideIndex == null || slideIndex === undefined)
      return;

    setSelectedTab(slideIndex.toString());

    document.getElementById("tab-" + slideIndex)?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }

  function preencheFotos(value: any, indice: any) {

    return (
      (fotos[indice]) ?
        (<>
          {fotos[indice].map((photo: any, index: any) => (
            <IonCol size="6" key={index} >
              <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '0px', paddingBottom: '10px', position: 'relative' }}>
                <div style={{ maxWidth: '350px', width: '100%', minHeight: '100px' }}>

                  {/* <a target='_blank' href={photo.webviewpath?.replace("small", "big")}>

                <IonImg src={photo.webviewpath} />
              </a> */}

                  <a target='_blank' href={photo.webviewpath?.replace("small", "big")}>
                    <img style={{ width: '100%', borderRadius: '5px' }} src={photo.webviewpath?.replace("small", "big")}></img>
                  </a>

                  {/* <IonButton fill='clear' color="tertiary" size="small" expand="block" onClick={() => {
                  setCaminhoParaExcluir(photo.webviewpath); setCaminhoIndiceParaExcluir(indice); setShowAlertConfirmarExclusaoFoto(true);
                }}>Excluir</IonButton> */}


                </div>
              </div>
            </IonCol>
          ))}

        </>) :
        (
          <>
            {/* {preencheCard(value, index)} */}
          </>
        )
    )
  }

  function preencheArquivos(value: any, indice: any) {

    return (
      (arquivos[indice]) ?
        (<>
          {arquivos[indice].map((arq: any, index: any) => (
            <IonCol size="6" key={index} >
              <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '0px', paddingBottom: '10px', position: 'relative' }}>
                <div style={{ maxWidth: '350px', width: '100%' }}>
                  <a target='_blank' href={arq.webviewpath?.split(";")[1]}>
                    {arq.webviewpath?.split(";")[0].split("|")[0]}
                  </a>
                  <IonButton style={{ margin: '10 0 10px 0', fontWeight: 'normal', width: '100%', "font-size": "12px" }} hidden={arq.webviewpath?.split(";")[0].split("|")[1] == "cont" || arq.webviewpath?.split(";")[0].split("|")[1] == undefined} color="tertiary" expand='block' fill="solid" size="small" onClick={() => {
                    carregarDadosAssinatura(arq.webviewpath?.split(";")[0].split("|")[1]);
                  }}>Assinado</IonButton>

                  <IonButton style={{ margin: '10 0 10px 0', fontWeight: 'normal', width: '100%', "font-size": "12px", "font-weight": "bold" }} hidden={arq.webviewpath?.split(";")[0].split("|")[1] != "cont" ||  localStorage.getItem("compartilhado") == "true"} fill='clear' color="tertiary" size="small" expand="block" onClick={() => {

                    setArquivoParaAssinar(arq.webviewpath); setArquivoIndiceParaAssinar(indice); setShowModalConfirmarAssinatura(true);

                  }}>Assinar</IonButton>
                </div>
              </div>
            </IonCol>
          ))}

        </>) :
        (
          <>
            {/* {preencheCard(value, index)} */}
          </>
        )
    )
  }

  function carregarDadosAssinatura(pk: any) {
    setShowModalDadosAssinatura(true);

    const consultar = async () => {


      setShowLoading(true);
      requestService(carregaAssinatura.url.replace("{id}", pk.replaceAll(/#/g, '%23')), {
        method: carregaAssinatura.method,
        headers: [
          ["token", localStorage.getItem("token") || ""],
          ["perfil", window.localStorage.getItem("perfil") || ""],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {

          //console.log(response.Item);
          setDadosAssinatura(response.Item);

          setAssinaturaBlob(response.Item?.assinaturaBase64);
          setShowLoading(false);
          setShowModalDadosAssinatura(true);

        },
        (error: any) => {
          setShowLoading(false);
          //console.log(error);
          history.replace("/primeiroacesso/");
        });
    }
    consultar();

  }

  function preencheCard(value: any, index: any) {


    return (
      (<>
        {/* {setarIndice()} */}
        <IonList style={{ "margin": "0px" }}>
          <IonItem style={{ "margin": "0px" }} lines="none" hidden={value.exibirInformacoes === "false"}>
            <IonIcon style={{ "margin-right": "6px" }} icon={informationCircleOutline} slot="start" />
            <div className="contentList">
              <IonListHeader hidden={false} lines="full">
                <IonLabel>Informações</IonLabel>
              </IonListHeader>

              <div dangerouslySetInnerHTML={{ __html: informacoes[index] }} style={{ whiteSpace: "pre-wrap", paddingTop: "6px" }} >
              </div>
            </div>
          </IonItem>

          <IonItem style={{ "margin": "0px" }} lines="none" hidden={value.exibirValor === "false"}>
            <IonIcon style={{ "margin-right": "6px" }} icon={logoUsd} slot="start" />
            <div className="contentList">

              <IonListHeader hidden={false} lines="full">
                <IonLabel>Valores</IonLabel>
              </IonListHeader>

              <div dangerouslySetInnerHTML={{ __html: valores[index] }} style={{ whiteSpace: "pre-wrap", paddingTop: "6px" }} >

              </div>
            </div>
          </IonItem>

          <IonItem style={{ "margin": "0px" }} lines="none" hidden={value.exibirFotos === "false"}>
            <IonIcon style={{ "margin-right": "6px" }} icon={camera} slot="start" />
            <div className="contentList">
              {/* <h1>Fotos</h1> */}


              <IonListHeader hidden={false} lines="full">
                <IonLabel>Fotos</IonLabel>
              </IonListHeader>




              <h2> <IonList lines="full" class="ion-no-margin">
                <IonGrid>
                  <IonRow>

                    {preencheFotos(value, index)}
                  </IonRow>
                </IonGrid>
              </IonList></h2>
            </div>
          </IonItem>

          <IonItem style={{ "margin": "0px" }} lines="none" hidden={value.exibirArquivos === "false"}>
            <IonIcon style={{ "margin-right": "6px" }} icon={receipt} slot="start" />
            <div className="contentList">


              <IonListHeader hidden={false} lines="full">
                <IonLabel>Arquivos</IonLabel>
              </IonListHeader>




              <h2> <IonList lines="full" class="ion-no-margin">
                <IonGrid>
                  <IonRow>

                    {preencheArquivos(value, index)}
                  </IonRow>
                </IonGrid>
              </IonList></h2>
            </div>
          </IonItem>
        </IonList>


      </>)
    )
  }

  function loadItensMenu(value: any, index: any) {

    let nomeIcone: string = value.icone;
    return (

      <IonSegmentButton value={index} id={"tab-" + index}>

        <p><IonIcon icon={icons[nomeIcone as keyof IconType]} ></IonIcon></p>
      </IonSegmentButton>

    )
  }


  const assinarDocumento = async () => {

    if (!checkedTermo) {
      Toast.show({
        text: "Você precisa aceitar os Termos de uso para assinar o documento.",
        duration: "long"
      });
    }
    else if (signaturePad.toData().length == 0) {
      Toast.show({
        text: "Você precisa assinar o documento.",
        duration: "long"
      });
    }
    else {
      setShowAlertConfirmarAssinatura(true);
    }

  }

  return (

    <IonPage className="OrdensWorkflow">
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          {/* <div>
            {carregarProjeto()}
          </div> */}
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack(); }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle className="ion-text-wrap" style={{ "padding-left": "20px", "padding-top": "0px", "padding-bottom": "0px", "text-align": "left" }}>{dadosProjeto ? (dadosProjeto.layoutSimplificado ? "" : dadosProjeto.nomeProjeto + " - ") + dadosProjeto.statusWorkflow : ""}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen={false}>

        <IonModal isOpen={showCarregando} className='my-custom-class aguarde'>
          <IonLabel className="helper">Aguarde, realizando operação</IonLabel>
        </IonModal>

        <div className="header">
          <div className="info" >
            <IonToolbar>
              <IonSegment scrollable value={selectedTab} onIonChange={(e) => { scrollToTop(); onTabChange(e.detail.value?.toString() ?? "") }}>
                {dadosProjeto?.configWorkflow?.map((valor: any, index: any) => (
                  loadItensMenu(valor, index)
                ))}
              </IonSegment>
            </IonToolbar>
          </div>
        </div>
        <div>
          <Swiper onSwiper={(swiper) => {
            setSwiperInstance(swiper);
          }} className={"ItinerarioSlides"} onSlideChange={() => onSlideChange()}>

            {dadosProjeto?.configWorkflow?.map((value: any, index: any) => (
              <SwiperSlide>
                <IonList>
                  <IonListHeader lines="full">
                    <IonLabel>{value.status}</IonLabel>
                  </IonListHeader>
                  {preencheCard(value, index)}


                </IonList>
              </SwiperSlide >
            ))}

          </Swiper>
        </div>

        <IonModal isOpen={showModalConfirmarAssinatura} onDidDismiss={() => { setShowModalConfirmarAssinatura(false); setShowAssinatura(false); setCheckedTermo(false); setAlertaPreenchimento(false); }} >
          <IonHeader>
            <IonToolbar color="light">
              <div className="input" style={{ display: 'block', alignItems: 'center', paddingLeft: '10px', fontSize: "10px" }}>
                <IonCheckbox style={{ 'margin-right': '8px', "color": "white" }} checked={checkedTermo} onIonChange={e => {

                  setCheckedTermo(e.detail.checked);
                  if (e.detail.checked) {
                    setShowAssinatura(true);
                    setBotaoAtivo(true);
                  }
                  else {
                    setShowAssinatura(false);
                    setBotaoAtivo(false);
                  }
                  readyPad();
                }}
                />
                Eu li e aceito os&nbsp;<a style={{ "color": "red" }} target='_blank' href={'https://xeguei-plt-welcome.s3.sa-east-1.amazonaws.com/termos/cliente' + (window.localStorage.getItem("marca") || '') + '/Termos_de_uso_assinatura_eletronica.pdf'}>Termos de Uso <IonIcon src={openOutline} /></a>&nbsp;para&nbsp;assinaturas&nbsp;eletrônicas
              </div>
              <IonButtons slot="start" onClick={() => { setShowModalConfirmarAssinatura(false); }}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent class="ion-padding">
            <div hidden={!showAssinatura}>
              <div id="signature-pad" style={{ "textAlign": "center" }}>

                <canvas className="signature-canvas" height="580" ></canvas>
              </div>
            </div>

          </IonContent>
          <IonFooter className="ion-no-border" >
            <IonToolbar>
              <IonButton fill='clear' size="small" disabled={!botaoAtivo} onClick={() => handleClear()} type="submit">Limpar</IonButton>
              <IonButton slot="end" size="small" disabled={!botaoAtivo} onClick={() => { assinarDocumento() }}>Assinar</IonButton>
            </IonToolbar>
          </IonFooter>
        </IonModal>

        <IonModal isOpen={showModalDadosAssinatura} onDidDismiss={() => { setShowModalDadosAssinatura(false); }} >
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Assinatura</IonTitle>
              <IonButtons slot="start" onClick={() => { setShowModalDadosAssinatura(false); }}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent class="ion-padding">

            <IonLabel>Assinado Por:</IonLabel>
            <IonItem lines="none">
              <IonLabel>{dadosAssinatura?.nome}</IonLabel>
            </IonItem>

            <IonLabel>CPF:</IonLabel>
            <IonItem lines="none">
              <IonLabel>{dadosAssinatura?.cpf}</IonLabel>
            </IonItem>

            <IonLabel>Data da assinatura:</IonLabel>
            <IonItem lines="none">
              <IonLabel>{dadosAssinatura?.dataAssinatura}</IonLabel>
            </IonItem>


            <IonLabel>Nome do documento:</IonLabel>
            <IonItem lines="none">
              <IonLabel>{dadosAssinatura?.nomeDocumento}</IonLabel>
            </IonItem>

            <IonLabel>Autenticidade:</IonLabel>
            <IonItem lines="none">
              <IonTextarea style={{ "--background": "#eeeeee", "font-size": "10px" }} rows={6} value={dadosAssinatura?.informacoesAdicionais} maxlength={250} disabled={true}></IonTextarea>
            </IonItem>

            <IonLabel>Assinatura:</IonLabel>
            <IonItem lines="none">
              <IonImg src={assinaturaBlob} />
            </IonItem>



          </IonContent>

        </IonModal>

        <IonAlert isOpen={showAlertConfirmarAssinatura}
          onDidDismiss={() => setShowAlertConfirmarAssinatura(false)}
          header={'Confirmar assinatura'}
          message={'Você <strong>confirma</strong> a assinatura desse documento?'}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: () => {


                setSavedSignature(signaturePad.toDataURL());
                setBotaoAtivo(false);
                const assinarDoc = async () => {



                  Toast.show({
                    text: "Aguarde a geração da assinatura.",
                    duration: "long"
                  });

                  // console.log("signaturePad.toDataURL()", signaturePad.toDataURL());
                  // console.log(arquivoParaAssinar, arquivoIndiceParaAssinar);

                  const resp = await fetch(assinarArquivoProjeto.url.replace("{id}", params.projetoid.replace(/#/g, "%23")),
                    {
                      method: assinarArquivoProjeto.method,
                      headers: [
                        ["token", localStorage.getItem("token") || ""],
                        ["perfil", window.localStorage.getItem("perfil") || ""],
                        ["marca", window.localStorage.getItem("marca") || ""],
                      ],
                      body: JSON.stringify({
                        'arquivo': arquivoParaAssinar,
                        'indice': arquivoIndiceParaAssinar,
                        'assinatura': signaturePad.toDataURL(),
                        'latitude': window.localStorage.getItem("latitude") || '',
                        'longitude': window.localStorage.getItem("longitude") || ''
                      }),
                      credentials: 'include'
                    });
                  const retorno = await resp.json();

                  //console.log("retorno", retorno);




                  if (retorno.message && retorno.message.Attributes && retorno.message.Attributes) {
                    preencherDadosOperacao(retorno.message.Attributes, false);
                    Toast.show({
                      text: "Documento assinado com sucesso.",
                      duration: "long"
                    });

                  }
                  else {
                    Toast.show({
                      text: "Ocorreu um erro ao assinar o documento, tente novamente mais tarde.",
                      duration: "long"
                    });
                  }

                  setShowModalConfirmarAssinatura(false);
                }


                assinarDoc();

              }

            }
          ]}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent >
    </IonPage >
  );


};

export default OrdensWorkflow;